import type { RateSnapshotsBrowserComponentProps } from './RateSnapshotsBrowserComponent';

export const RateSnapshotsBrowserComponent = {
    MountAsync: async (target: HTMLElement, props: RateSnapshotsBrowserComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RateSnapshotsBrowserComponent } = await import('./RateSnapshotsBrowserComponent');
        return await mountReactComponentAsync(target, RateSnapshotsBrowserComponent, props);
    }
};
